// extracted by mini-css-extract-plugin
export var aiStarIcon = "_az-4";
export var closeButton = "_az-6";
export var dismissButton = "_az-3";
export var editImageWithAiContainer = "_az-8";
export var imageUploadWrapper = "_az-7";
export var misspelledWord = "_az-5";
export var spellCheckContainer = "_az-2";
export var spin = "_az-1";
export var spinning = "_az-0";